import React from 'react';

export const FinancialColumnHeadersField = ({ uiSchema }) => {
    const columns = (uiSchema && uiSchema.columns) || [];

    return (
        <div className="row financial-grid-row">
            <div className="col-12 col-md-4 financial-grid-label-cell" />
            {columns.map((column) => (
                <div
                    key={column}
                    className="col-12 col-md-4 financial-grid-header-cell"
                >
                    <strong>{column}</strong>
                </div>
            ))}
        </div>
    );
};

export const FinancialHelperTextField = ({ uiSchema }) => (
    <>
        <span className="financial-helper-icon" aria-hidden="true">ⓘ</span>
        <span>{uiSchema.helperText}</span>
    </>
);

export const AssetsLiabilitiesTableHeaderField = () => (
    <div className="row financial-table-header-row">
        <div className="col-12 financial-table-item-col financial-table-col-item">Item</div>
        <div className="col-12 financial-table-value-col financial-table-col-value">Current Value</div>
        <div className="col-12 financial-table-notes-col financial-table-col-notes">Notes</div>
    </div>
);

export const FinancialTableRowLabelField = ({ schema, uiSchema }) => (
    <span className="financial-table-row-label-text">
        {schema.title}
        {uiSchema && uiSchema.requiredLabel && <span className="required"> *</span>}
    </span>
);

export const FinancialBreakdownValidationField = ({ errorSchema }) => {
    const messages = (errorSchema && errorSchema.__errors) || [];

    if (messages.length === 0) {
        return null;
    }

    return (
        <div className="financial-breakdown-error-message text-danger">
            {messages.map((message) => (
                <div key={message}>{message}</div>
            ))}
        </div>
    );
};

export const FinancialCalculatedNotesField = () => (
    <em>Calculated</em>
);
